import { tryParseDate } from '@shared/functions/try-parse-date';
import { BcmCostCenter, BcmCostCenterDto } from '@shared/models/bcm-cost-center';

export interface BcmDepartmentDto {
    id: number;
    name: string;
    description: string | null;
    bcm_employees_id: number | null;
    deputy_bcm_employees_id?: number | null;
    headDisplayName?: string | null;
    employeeCount?: number;
    costCentersSummary?: string | null;
    costCenters?: BcmCostCenterDto[];
    insertedOn: string;
    insertedBy: string;
    lastUpdateOn: string | null;
    lastUpdateBy: string | null;
}

export class BcmDepartment {
    id: number;
    name: string;
    description: string | null;
    bcm_employees_id: number | null;
    deputy_bcm_employees_id: number | null;
    headDisplayName: string | null;
    employeeCount: number;
    costCentersSummary: string;
    costCenters: BcmCostCenter[];
    insertedOn: Date | null;
    insertedBy: string;
    lastUpdateOn: Date | null;
    lastUpdateBy: string | null;

    constructor(dto: BcmDepartmentDto = {} as BcmDepartmentDto) {
        this.id = dto.id;
        this.name = dto.name;
        this.description = dto.description ?? null;
        this.bcm_employees_id = dto.bcm_employees_id ?? null;
        this.deputy_bcm_employees_id = dto.deputy_bcm_employees_id ?? null;
        this.headDisplayName = dto.headDisplayName ?? null;
        this.employeeCount = dto.employeeCount ?? 0;
        this.costCentersSummary = dto.costCentersSummary ?? '';
        this.costCenters = (dto.costCenters ?? []).map(costCenter => new BcmCostCenter(costCenter));
        this.insertedOn = tryParseDate(dto.insertedOn);
        this.insertedBy = dto.insertedBy;
        this.lastUpdateOn = tryParseDate(dto.lastUpdateOn);
        this.lastUpdateBy = dto.lastUpdateBy;
    }

    get employeeCountLabelKey(): string {
        return 'bcmDepartments.table.employeeCountValue';
    }

    toString(): string {
        return this.name || '';
    }
}
